export const zoeStrings = {
	composerPlaceholder: "Ask Zoe anything…",
	emptyStateHeadline: "Hi — what would you like to work on?",
	emptyStatePromptsFallback: [
		"Summarize what's slipping in my pipeline this quarter.",
		"Which deals are most likely to close this month?",
		"What tasks do I have due this week?",
		"List my overdue follow-ups."
	],
	thinking: {
		default: "Thinking…",
		drafting: "Drafting…",
		writing: "Writing…",
		looking: "Looking at this page…"
	},
	sourcesLabel: "Sources",
	verifyDisclaimerSend:
		"Zoe can make mistakes. Verify important info before sending.",
	verifyDisclaimerApply: "Zoe can make mistakes. Review before applying.",
	errors: {
		interrupted: "Something interrupted that — want me to try again?",
		rateLimited: "Zoe needs a moment. Try again in a few seconds.",
		network: "Couldn't reach Zoe. Check your connection and try again.",
		serverContext:
			"Zoe couldn't read this page. Try asking a more specific question."
	},
	artifactFailure: {
		editor_closed:
			"The document editor is closed — open the document to apply this draft.",
		document_mismatch:
			"This draft belongs to a different document — open it to apply.",
		stale_selection:
			"The document changed since this draft was made — ask Zoe for a fresh version.",
		apply_failed:
			"Couldn't apply this draft — try again or ask Zoe for a new version."
	},
	editorNotice: {
		editor_closed:
			"The document editor closed while Zoe was drafting — reopen the document to apply these changes.",
		document_mismatch:
			"Zoe's drafts target a different document — open it to apply them."
	},
	actions: {
		retry: "Try again",
		stop: "Stop",
		edit: "Edit",
		copy: "Copy",
		regenerate: "Try again",
		apply: "Apply"
	},
	contextLabel: "Context",
	contextAdd: "Add"
} as const;

export type ZoeStrings = typeof zoeStrings;
